import { useEffect } from 'react';
import { motion } from 'motion/react';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';

export function Celebration({ day, onClose }: { day: number; onClose: () => void }) {
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => event.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="celebration" role="dialog" aria-modal="true">
      <div className="confetti-field">{Array.from({ length: 30 }, (_, index) => <i key={index} style={{ '--i': index } as React.CSSProperties} />)}</div>
      <motion.div className="celebration-card" initial={{ opacity: 0, scale: .7, y: 30 }} animate={{ opacity: 1, scale: 1, y: 0 }}>
        <div className="celebration-icon"><Sparkles /></div>
        <span className="eyebrow">+100 XP · streak protected</span>
        <h2>Day {day}, done.</h2>
        <p>You showed up and moved the line. That’s how interview confidence gets built.</p>
        <Link className="button primary" to={day < 60 ? `/day/${day + 1}` : '/progress'} onClick={onClose}>
          {day < 60 ? 'Preview tomorrow' : 'See your journey'} <ArrowRight size={18} />
        </Link>
        <button className="text-button" onClick={onClose}>Stay here</button>
      </motion.div>
    </div>
  );
}

